/* eslint-disable import/no-anonymous-default-export */
export default {
  "nav.home": "Home",
  "nav.about": "About",
  "nav.services": "Services",
  "nav.creators": "Creators",
  "nav.contact": "Contact",
  "lang.en": "EN",
  "lang.ko": "KO",
  "lang.zh": "中文",

  "hero.tagline": "Xiaohongshu Marketing & Live Commerce Agency",
  "hero.title_line1": "On Xiaohongshu,",
  "hero.title_line2": "become a brand people truly love",
  "hero.description": "Dragonfruit specializes in helping Korean brands enter Xiaohongshu. From content planning and K-creator live commerce to store operations and China market strategy, we walk with you from start to finish to build a brand that Chinese consumers genuinely connect with.",
  "hero.cta_primary": "Free Consultation",
  "hero.cta_secondary": "Explore Services",

  "stats.countries": "500+",
  "stats.countries_label": "Xiaohongshu Lives Hosted",
  "stats.partners": "80+",
  "stats.partners_label": "Brands Entered China",
  "stats.support": "15M+",
  "stats.support_label": "Total Viewers",
  "stats.global_hub": "98%",
  "stats.global_hub_label": "Client Retention Rate",

  "services.title": "We build brands that work on Xiaohongshu",
  "services.content_production": "Xiaohongshu Content Marketing",
  "services.content_production_desc": "We create content that makes Chinese consumers stop scrolling and hit save. Through algorithm analysis and trend forecasting, we craft stories that naturally embed your brand into the Xiaohongshu ecosystem.",
  "services.live_operations": "Xiaohongshu Live Commerce",
  "services.live_operations_desc": "A live show with a K-creator isn't just a sales event. We design moments that feel like trusted friend recommendations—authentic reviews and immersive production that turn one broadcast into a fan-making experience.",
  "services.commerce_support": "Xiaohongshu Store Management",
  "services.commerce_support_desc": "From store setup and product listing to order fulfillment, customer service, and data reporting. We manage your store with the same care as our own, building a reliable revenue channel.",
  "services.shop_management": "K-Creator Matching",
  "services.shop_management_desc": "We look beyond numbers. We find K-creators who genuinely align with your brand values and build long-term partnerships. Performance is shared transparently, always.",

  "about.heading": "About Us",
  "about.company_name": "Dragonfruit",
  "about.section_title": "Why Dragonfruit",
  "about.company_desc": "Dragonfruit connects Korean brands that don't know Xiaohongshu with Chinese consumers who don't know Korea. We're not just an agency. We're a partner who co-designs and takes responsibility for your growth.",
  "about.company_desc2": "Xiaohongshu is where over 300 million Chinese consumers search, read reviews, and decide what to buy. But China's market has different cultures and algorithms. Dragonfruit helps Korean brands get noticed and loved here—through content, live commerce, store management, and creator matching.",
  "about.vision_title": "Vision",
  "about.vision_text": "To become the most natural bridge between Korean sensibility and Chinese trends.",
  "about.vision_text2": "It's not just about selling products. Our goal is to build real relationships where Chinese consumers genuinely like, seek out, and recommend Korean brands. That's why we're named Dragonfruit—we help brands become as unique and memorable as the fruit itself.",
  "about.mission_title": "Mission",
  "about.mission_text": "We tell real stories. We don't fake numbers, cut corners on content, or chase one-time sales.",
  "about.mission_text2": "Our job is to build brands that are loved on Xiaohongshu for the long run. We read Chinese consumers' needs accurately, combine them with K-creators' authentic charm, and create real results—while protecting your brand identity every step of the way.",
  "about.values_title": "Core Values",
  "about.values_subtitle": "Five principles that guide how Dragonfruit works. Applied equally to clients, creators, and our own team.",
  "about.values.growth": "Understand Chinese consumers first",
  "about.values.growth_desc": "Before data and algorithms, we deeply understand what Chinese consumers want and how they communicate. That's where every strategy begins.",
  "about.values.creativity": "Deliver K-sensibility properly",
  "about.values.creativity_desc": "We translate and recreate the unique sensibility and stories of Korean brands in ways that Chinese consumers naturally embrace.",
  "about.values.mindset": "Transparent, together",
  "about.values.mindset_desc": "We share live sales, campaign data, and store performance openly. Long-term partnerships built on trust are our pride.",
  "about.values.integrity": "We don't play games with content",
  "about.values.integrity_desc": "We never produce throwaway content. Every piece we create is worth saving, commenting on, and sharing with friends.",
  "about.values.impact": "Brand building over quick sales",
  "about.values.impact_desc": "We don't settle for one-time live revenue. We believe real success is building assets that help your brand grow sustainably on Xiaohongshu.",

  "contact.heading": "Contact",
  "contact.subtitle": "Ready to start on Xiaohongshu? Tell us about your brand's current situation and goals, and we'll co-design the right strategy together. Consultations are always free.",
  "contact.full_name": "Name",
  "contact.full_name_placeholder": "Enter your name",
  "contact.email": "Email",
  "contact.email_placeholder": "Enter your email",
  "contact.phone": "Phone",
  "contact.phone_placeholder": "Enter your phone number",
  "contact.datetime": "Schedule",
  "contact.service": "What service are you interested in?",
  "contact.service_placeholder": "Select inquiry type",
  "contact.service_content": "Content Marketing",
  "contact.service_live": "Live Commerce",
  "contact.service_commerce": "Store Management",
  "contact.service_creator": "Creator Matching",
  "contact.service_other": "Other",
  "contact.send": "Request Free Consultation",
  "contact.success": "Your inquiry has been received! The Dragonfruit team will reach out within 24 hours.",
  "contact.address": "60, Nambusunhwan-ro 339-gil, Seocho-gu, Seoul, HJ Tower 402-22, 4F",
  "contact.postal": "06722, Republic of Korea",
  "contact.website": "https://d-fruit.net/",
  "contact.address_label": "Address",
  "contact.opening_hours": "Business Hours",
  "contact.mon": "Mon",
  "contact.tue": "Tue",
  "contact.wed": "Wed",
  "contact.thu": "Thu",
  "contact.fri": "Fri",
  "contact.hours": "10:00 AM - 7:00 PM",

  "footer.copyright": "© 2025 Dragonfruit. All Rights Reserved.",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms of Service",

  "creators.heading": "Our Creators",
  "creators.subtitle": "K-creators thriving on Xiaohongshu with Dragonfruit. They're not just influencers—they're true specialists in their fields, building deep trust with Chinese consumers.",
  "creators.filter_all": "All",
  "creators.filter_beauty": "Beauty",
  "creators.filter_fashion": "Fashion",
  "creators.filter_food": "Food",
  "creators.filter_lifestyle": "Lifestyle",
  "creators.filter_travel": "Travel",
  "creators.followers": "Followers",
  "creators.instagram": "Instagram",
  "creators.tiktok": "TikTok",
  "creators.xiaohongshu": "Xiaohongshu",
  "creators.view_profile": "View Profile",
  "creators.join_title": "We're looking for creators to grow with",
  "creators.join_tagline": "Join Us",
  "creators.join_desc": "Is there real passion in your content? If you have the drive to connect with Chinese consumers, Dragonfruit will walk that path with you. We don't just schedule broadcasts—we co-design your long-term growth.",
  "creators.join_cta": "Apply as Creator",
  "creators.join_name": "Name",
  "creators.join_name_placeholder": "Enter your name",
  "creators.join_email": "Email",
  "creators.join_email_placeholder": "Enter your email",
  "creators.join_phone": "Phone",
  "creators.join_phone_placeholder": "Enter your phone number",
  "creators.join_category": "Content Category",
  "creators.join_category_placeholder": "Select category",
  "creators.join_message": "Why you want to join",
  "creators.join_message_placeholder": "Tell us about your content style, what you want to show on Xiaohongshu, and why you want to join Dragonfruit (max 500 characters)",
  "creators.join_send": "Submit Application",
  "creators.join_success": "Application received! We'll contact you individually after review.",
  "creators.no_results": "No creators found in this category.",

  "nav.brands": "Brands",

  "brands.hero.tagline": "Global Brand Growth Partner with Xiaohongshu at the Core",
  "brands.hero.title_line1": "Korean Brands Entering China,",
  "brands.hero.title_line2": "Dragonfruit Is With You",
  "brands.hero.description": "From Xiaohongshu to TikTok Shop, Shopify, and Douyin. We walk with you from start to finish to build a brand that Chinese consumers truly love.",
  "brands.hero.cta": "Free Consultation",

  "brands.services.title": "Services for Brands",
  "brands.services.subtitle": "Xiaohongshu is the main stage. Expanding to global platforms happens naturally.",
  "brands.services.xiaohongshu.title": "Xiaohongshu One-Stop Solution",
  "brands.services.xiaohongshu.desc": "Content marketing, live commerce, store operations, and K-creator matching. One partner handles your entire Xiaohongshu journey.",
  "brands.services.global.title": "Global Platform Expansion",
  "brands.services.global.desc": "Expand to TikTok Shop, Shopify, Douyin, and other China and global platforms. Diversify revenue channels with platform-optimized strategies.",
  "brands.services.analytics.title": "Data-Driven Performance",
  "brands.services.analytics.desc": "Transparently share real-time data on content views, live sales, and store conversion rates. Systematic, results-focused operations guaranteed.",

  "brands.locations.title": "Global Network",
  "brands.locations.heading": "Headquartered in Korea, supporting brand growth across global key markets",
  "brands.locations.subtitle": "Headquartered in Korea, serving China, Japan, USA, Canada, Middle East, and Europe with localized strategies for each region.",
  "brands.locations.stat_brands": "Brands",
  "brands.locations.stat_creators": "Creators",
  "brands.locations.stat_campaigns": "Campaigns",
  "brands.locations.korea": "Korea (HQ)",
  "brands.locations.korea_desc": "Xiaohongshu content planning, K-creator matching, live commerce strategy",
  "brands.locations.japan": "Japan",
  "brands.locations.japan_desc": "Live commerce operations support, localized content production, Japanese platform expansion consulting",
  "brands.locations.china": "China",
  "brands.locations.china_desc": "Xiaohongshu store management, Douyin live commerce, local partner network",
  "brands.locations.usa": "USA",
  "brands.locations.usa_desc": "TikTok Shop entry support, Shopify global store operations, local influencer collaboration",
  "brands.locations.canada": "Canada",
  "brands.locations.canada_desc": "North America tailored content strategy, global e-commerce channel expansion, multicultural marketing",
  "brands.locations.middle_east": "Middle East",
  "brands.locations.middle_east_desc": "Middle East beauty & fashion trend analysis, localized content planning, regional platform adaptation",
  "brands.locations.europe": "Europe",
  "brands.locations.europe_desc": "European market entry strategy, global brand localization, cross-border commerce support",

  "brands.process.title": "4 Steps to Brand Success",
  "brands.process.step1": "Free Consultation",
  "brands.process.step1_desc": "We listen to your brand's current situation and China market entry goals",
  "brands.process.step2": "Strategy Design",
  "brands.process.step2_desc": "We design a custom Xiaohongshu content strategy and live commerce roadmap",
  "brands.process.step3": "Execution & Operations",
  "brands.process.step3_desc": "Full management of content production, live streaming, and store operations",
  "brands.process.step4": "Performance Analysis",
  "brands.process.step4_desc": "Continuous optimization and growth driven by data insights",

  "brands.cta.title_line1": "Your Brand's Xiaohongshu Success",
  "brands.cta.title_line2": "Starts Now",
  "brands.cta.desc": "Consultations are always free. Let's co-design the right Xiaohongshu strategy for your brand.",
  "brands.cta.button": "Request Free Consultation",
}
